/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-02-26 15:07:41
 * @modify date 2020-02-26 15:07:41
 * @desc [description]
 */
import axios from 'axios';

/**
 * update address put api
 * to update address content */
export async function updateAddress(data, id) {
  let result = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/updatePlantLocation/${id}`, data)
    .then((response) => {
      if (response.status === 200 && response.data) result = response.data;
    })
    .catch((err) => {
      console.log('set address java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * update address put api
 * to update address content */
export async function updateHeadquarterAddress(data) {
  let result = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/updateHeadquarterAddress`, data)
    .then((response) => {
      if (response.status === 200 && response.data) result = response.data;
    })
    .catch((err) => {
      console.log('set address java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * addresss delete api
 * to delete address */
export async function deleteAddress(id) {
  let result = '';
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/deletePlantLocation/${id}`)
    .then((response) => {
      if (response) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get team_member java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getMultiplantAddress get api
 * to address list */
export async function getMultiplantAddress() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/getPlantLocation`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
        console.log('reuslt', result);
      }
    })
    .catch((err) => {
      console.log('get address java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getHeadQuarterAddress get api
 * to address list */
export async function getHeadQuarterAddress() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/getHeadquarterAddress`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
        console.log('reuslt', result);
      }
    })
    .catch((err) => {
      console.log('get address java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * addAddress post api
 * to add new address  */
export async function addAddress(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/addPlantLocation`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('add address java api error', err); // eslint-disable-line no-console
    });
  return result;
}
